import React, { useEffect } from 'react';
import { api } from './App';

const RELEASES = [
  {
    version: 'v1.1',
    date: '6 April 2026',
    iso: '2026-04-06',
    items: [
      {
        title: 'SRA Questions — performance now shown in topic view',
        detail: 'Your SRA accuracy for each topic area now appears alongside confidence in FLK1 and FLK2. The dashboard priority list also shows your SRA accuracy badge when relevant.',
      },
      {
        title: 'Practice mode — full question-by-question review',
        detail: 'After completing a practice set in SRA Questions, you can review every question with your answer vs. the correct answer — the same breakdown as exam mode.',
      },
      {
        title: 'Law Drills support added',
        detail: 'You can now import MCQ results from Law Drills as well as BARBRI. Select your provider in the MCQ Results tab.',
      },
      {
        title: 'Recall — lighter confidence adjustment',
        detail: 'Self-rated confidence from recall sessions now blends more gently with your existing confidence, so a single session will not shift your rating by a large amount.',
      },
      {
        title: 'Onboarding — redesigned import step',
        detail: 'The starting flow now shows three full-page options: download our template, import your own spreadsheet, or start fresh.',
      },
      {
        title: 'Planner — session saving fixed',
        detail: 'Fixed a bug where planner sessions could disappear after navigating away. Sessions now save on first entry.',
      },
      {
        title: 'Progress chart — FLK1/FLK2 filter',
        detail: 'You can now view FLK1 and FLK2 confidence trends separately using the toggle above the chart.',
      },
    ],
  },
  {
    version: 'v1.0',
    date: '2 April 2026',
    iso: '2026-04-02',
    items: [
      {
        title: 'SQETrack is live',
        detail: 'Track your confidence across 259 FLK1 and FLK2 topics, import BARBRI practice results, practise with 220 SRA sample questions, plan your revision week by week, and monitor your progress toward exam day.',
      },
    ],
  },
];

export default function Changelog({ onViewed }) {
  useEffect(() => {
    // Mark changelog as viewed
    api('/api/settings', {
      method: 'POST',
      body: JSON.stringify({ changelog_last_viewed: new Date().toISOString().slice(0, 10) }),
    });
    if (onViewed) onViewed();
  }, []); // eslint-disable-line

  return (
    <div className="changelog-page">
      <div className="changelog-header">
        <div className="changelog-title">What is new</div>
        <div className="changelog-subtitle">SQETrack release notes</div>
      </div>
      <div className="changelog-list">
        {RELEASES.map((release, ri) => (
          <div key={release.version} className={`changelog-release ${ri === 0 ? 'changelog-release--open' : ''}`}>
            <div className="changelog-release-header-static">
              <div className="changelog-release-left">
                <span className="changelog-version" style={{ paddingLeft: 16 }}>{release.version}</span>
                <span className="changelog-date">{release.date}</span>
              </div>
            </div>
            <div className="changelog-items">
              {release.items.map((item, i) => (
                <div key={i} className="changelog-item">
                  <div className="changelog-item-title">{item.title}</div>
                  <div className="changelog-item-detail">{item.detail}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Export for use in App.js to determine whether to show "New" badge
export const LATEST_CHANGELOG_DATE = RELEASES[0].iso;
